import { render, staticRenderFns } from "./ChooseValuesSlide.vue?vue&type=template&id=573ffabc"
import script from "./ChooseValuesSlide.vue?vue&type=script&lang=js"
export * from "./ChooseValuesSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports